import { useCallback, useEffect, useRef } from 'react';

type EventHandler<Arguments extends readonly unknown[], ReturnValue> = (
  ...arguments_: Arguments
) => ReturnValue;

export function useStableEventHandler<
  Arguments extends readonly unknown[],
  ReturnValue,
>(
  handler: EventHandler<Arguments, ReturnValue>
): EventHandler<Arguments, ReturnValue> {
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  return useCallback(
    (...arguments_: Arguments) => handlerRef.current(...arguments_),
    []
  );
}
